import {NavLink} from "react-router-dom"

export const CustomerLink = ({customer}: { customer: string }) => {
    return (
        <NavLink to={`/customers/${customer}`}>{customer}</NavLink>
    )
}